import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import type { Maybe } from '@/lib/types';
import { theme } from '@/theme';

export const FlexGrowSpace = styled(Box)`
  // conditionally set flex-grow
  ${theme.media.md.down} {
    flex-grow: 1;
  }
`;

export const CTAWrappersContainer = styled.div<{
  $isCountDown?: boolean | null;
  $mediaWrapperType?: string;
  textAlignment: string;
  type: Maybe<string>;
  urlDirection?: string;
  urlPosition?: string;
}>`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 24px;
  ${({ type }) =>
    (type === 'MediaBanner' || type === 'SectionBanner') &&
    css`
      margin-top: initial;
    `}
  ${({ textAlignment }) => css`
    justify-content: ${textAlignment};
  `}
  ${({ urlDirection, urlPosition }) =>
    urlDirection === 'column' &&
    css`
      flex-direction: column;
      align-items: ${urlPosition};
    `}
  ${({ urlDirection, urlPosition }) =>
    urlDirection === 'row' &&
    css`
      flex-direction: row;
      justify-content: ${urlPosition};
    `}
    ${({ theme, type, urlDirection }) =>
    type === 'Text' &&
    urlDirection === 'row' &&
    css`
      flex-wrap: wrap;
      ${theme.media.md.up} {
        margin-top: ${theme.spacing(4)};
      }
      ${theme.media.md.down} {
        margin-top: ${theme.spacing(3)};
      }
    `}
  ${({ theme, type, urlDirection }) =>
    type === 'Text' &&
    urlDirection === 'column' &&
    css`
      margin-top: ${theme.spacing(3)};
    `}
    ${({ $mediaWrapperType, theme }) =>
    ($mediaWrapperType === 'MediaAndBottomText' ||
      $mediaWrapperType === 'MediaAndSideText' ||
      $mediaWrapperType === 'MediaBanner') &&
    theme.media.md.down &&
    css`
      width: 100%;
    `}
    ${({ type }) =>
    type === 'SquadCard' &&
    css`
      flex: 1;
      justify-content: flex-end;
    `} 
    ${({ $isCountDown, theme }) =>
    $isCountDown &&
    css`
      margin-top: ${theme.spacing(3)};
      ${theme.media.md.up} {
        margin-top: ${theme.spacing(4)};
      }
    `}
`;
export const CTAWrapper = styled(Box)<{
  $hasSecondCTA: boolean;
  $urlDirection?: string;
}>`
  ${theme.media.md.down} {
    width: 100%;
  }
  @media (min-width: 991px) and (max-width: 992px) {
    width: 100%;
  }

  ${({ $hasSecondCTA, $urlDirection }) =>
    $hasSecondCTA &&
    $urlDirection !== 'column' &&
    css`
      flex-basis: 100%;
      & > a {
        padding: 0;
        white-space: wrap;
      }
    `};
`;
export const HeadingWrapper = styled(Box)<{
  $isShowPrice: boolean;
  $type: Maybe<string>;
}>`
  ${({ $type, theme }) =>
    $type === 'Icon' &&
    css`
      ${theme.media.md.up} {
        p {
          white-space: nowrap;
        }
      }
    `}
  ${({ $isShowPrice, $type, theme }) =>
    ($type === 'Icon' || $isShowPrice) &&
    css`
      margin-bottom: ${theme.spacing(1)};
    `}
`;

export const Pricing = styled(Flex)`
  align-items: center;

  ${({ theme }) => theme.media.md.down} {
    justify-content: center;
  }
`;

export const Subheading = styled.span<{
  $boldText?: boolean;
}>`
  text-transform: uppercase;
  ${({ $boldText }) =>
    !!$boldText &&
    css`
      font-weight: bold;
    `}
`;
